$('.payments__date_js').on('click', function() {
    $(this).toggleClass('open').parent().find('.payments-table-block').slideToggle();
});


// WEBPACK FOOTER //
// ./src/common/modules/payments-history/payments-history.js